import { render, staticRenderFns } from "./statsTable.vue?vue&type=template&id=f07b48aa&scoped=true&"
import script from "./statsTable.vue?vue&type=script&lang=js&"
export * from "./statsTable.vue?vue&type=script&lang=js&"
import style0 from "./statsTable.vue?vue&type=style&index=0&id=f07b48aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b48aa",
  null
  
)

export default component.exports